module.exports = __webpack_public_path__ + "fonts/Inter-200-greek32.eb1153e.woff2";